import { render, staticRenderFns } from "./DataVizView.vue?vue&type=template&id=81a3d458&scoped=true"
import script from "./DataVizView.vue?vue&type=script&lang=js"
export * from "./DataVizView.vue?vue&type=script&lang=js"
import style0 from "./DataVizView.vue?vue&type=style&index=0&id=81a3d458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a3d458",
  null
  
)

export default component.exports